import {clientIconSrc} from './clientTools';

// Shared by the public install guide, Brief and plan connection window.
export default function ClientToolPicker({tools,selected,onSelect,connected=new Set()}) {
  return <div className="pabs-client-picker">
    <div className="pabs-brief-tools" role="group" aria-label="Your client">
      {tools.map(tool=><button type="button" key={tool.id} className="pabs-brief-tool" aria-pressed={selected===tool.id} aria-label={connected.has(tool.id)?`${tool.label}, connected`:tool.label} onClick={()=>onSelect(tool.id)}>
        <img src={clientIconSrc(tool)} alt="" width="22" height="22" className={tool.monochrome ? 'pabs-client-icon-monochrome' : undefined}/>
        <span>{tool.label}{connected.has(tool.id) && <span className="pabs-install-connected-mark" aria-hidden="true"> ✓</span>}</span>
      </button>)}
    </div>
  </div>;
}
